import { type LinkProps } from 'next/link';

import styled from '@emotion/styled';

import theme from '@app/theme';

import { Button, type ButtonProps, Link } from '@shared/ui-kit';

type LinkStyledProps = LinkProps &
  ButtonProps & {
    isActive: boolean;
  };

const LinkStyled = styled(
  ({ isActive, href, scroll, replace, prefetch, ...props }: LinkStyledProps) =>
    !isActive ? (
      <Link
        href={href}
        scroll={scroll}
        replace={replace}
        prefetch={prefetch}
        {...props}
      />
    ) : (
      <Button
        variant="unstyled"
        href={undefined}
        {...props}
      />
    ),
)`
  color: ${theme.colors.gray['700']};
  padding: ${theme.sizes['2']};
  font-weight: ${({ isActive }) => {
    return isActive ? 'bold' : 'normal';
  }};
  &:hover {
    color: ${theme.colors.datascopeBlue['600']};
  }
  &:active {
    color: ${theme.colors.datascopeBlue['700']};
  }
`;

export default LinkStyled;
